export const templateComponentEnabledKeys = [
  "mock-component",
  "breadcrumbs",
  "call-to-action",
  "dated-searches",
  "check-prices",
  "deals",
  "page-heading",
  "page-heading_wizard",
  "separator",
  "airport-address",
  "price-trend-graph",
  "link-juice",
  "property-filters",
  "property-filters_pills",
  "property-filters_sort",
  "hotel-recent-reviews",
  "hotel-recent-reviews_view",
  "hotel-recent-reviews_thumbnail-image-left-card",
  "hotel-recent-reviews_header-image-card",
  "hotels",
  "hotels_view",
  "hotels_carousel",
  "hotels_travellers-loved",
  "hotels_summarized-hotels",
  "hotels_summarized-hotels-carousel",
  "frequently-asked-questions",
  "destination-hero",
  "destination-neighborhoods",
  "te-neighborhood_neighborhood_with_dx_hsr",
  "twitter-embed",
  "links",
  "top-cities",
  "editorial",
  "wizard-hotel-pwa-v2",
  "tab-group",
  "recently-viewed-hotels",
  "region",
  "region_meso-collapsible-group",
  "region_mobile-confidence-messages-carousel",
  "region_multi-column",
  "NativeAdContainerRegion",
  "region_nts-flex-item",
  "region_native-tile-showcase",
  "region_theme-selector",
  "region_toggle",
  "region_responsive-toggle",
  "region_two-buttons",
  "region_property-filters-interactive",
  "region_wizard",
  "region_FullWidthWizard",
  "region_FullWidthBreadcrumbs",
  "region_FullWidthConfidenceMessages",
  "region_CallToActionGroup",
  "region_all-b-padding-three",
  "region_StorefrontConfidence",
  "region_all-cell-1-3",
  "region_dx-sidebar-content",
  "region_dx-page-header",
  "region_dx-main-content",
  "region_dx-page-content",
  "region_SEO links",
  "region_CenteredDestinationWizard",
  "region_NoBackgroundConfidenceMessages",
  "region_RecentlyBookedReviewedNoBorderBkg",
  "region_NativeShowcase",
  "region_Weekend Getaways",
  "region_PropertyHeroImage",
  "region_PropertyReviewHeadline",
  "region_EdgePaddingWrapper",
  "region_HeroEditorial",
  "region_banner_ad_1",
  "region_geo_hotels_1",
  "region_expand-collapse-subregions",
  "star-rating-links",
  "wizard-hotel-pwa",
  "maps",
  "maps_button",
  "region_spacing-container",
  "te-neighborhood",
  "dynamic-vendor-content",
  "maps_dynamic",
  "wizard",
  "hotels_image-top",
  "hotels_image-left-small",
  "hotels_image-left-large",
  "hotels_image-half",
];
